import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CurrencyConverter from '../../CurrencyConverter';

import cs from '../../commonStyle.css';
import s from '../ViewMessage.css';

const SubTotal = (props) => {

    const { discountType, currency, discount } = props;

    return (
        <div className={cx(cs.dataTableGrid, cs.paymentDivider, 'discountText')}>
            <div className={cx(cs.commonSmallText16, cs.textStart)}>{discountType}</div>
            <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                <span>-&nbsp; <CurrencyConverter amount={discount} from={currency} /> </span>
            </div>
        </div>
    );
}

export default withStyles(cs, s)(SubTotal);

